import { render, staticRenderFns } from "./EzButton.vue?vue&type=template&id=254b04c7&"
import script from "./EzButton.vue?vue&type=script&lang=js&"
export * from "./EzButton.vue?vue&type=script&lang=js&"
import style0 from "./EzButton.vue?vue&type=style&index=0&id=254b04c7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports